import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { FormGroup, Label, Input, Form, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import getFormPreferences from "../../../api/getFormPreferences";
import { toggleAge, toggleName, togglePosition, togglePreference as togglePreferenceAction, setPreferences } from "../../../redux/preferencesSlice";
import MinimizableContainer from "./MinimizableContainer";
import Loader from '../../utilities/loader';

const Preferences = ({
  // togglePreference,
  isActive,
  handleClose
  // minimized,
  // setMinimized,
}) => {
  const preferencesStyle = {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: "0px",
    transition: "left 400ms ease-in-out",
    left: `${isActive ? 0 : "100vw"}`,
    zIndex: 1,
    background: "white",
  };

  const selectedProject = useSelector(state => state.selectedProject);
  const data = useSelector((state) => state.preferences);
  const dispatch = useDispatch();

  const { form_name } = useParams();
  const { isLoading, data: preferences } = useQuery(
    ["getFormPreferences", form_name],
    () => getFormPreferences(selectedProject.name, form_name),
    {
      refetchOnWindowFocus: false,
      staleTime: 0,  // Data is stale immediately
      cacheTime: 0, // Do not cache the data
    }
  );


  useEffect(() => {
    let localPreferences = localStorage.getItem('preferences')
    let localPreferencesObj

    if (localPreferences) {
      localPreferencesObj = JSON.parse(localPreferences)
    }

    if (localPreferencesObj && localPreferencesObj.hasOwnProperty(form_name)) {
      dispatch(setPreferences(localPreferencesObj[form_name]))
      return
    }

    if (preferences) {
      let init = preferences?.data?.data;
      let filteredInit = init?.filter(obj => {
        return Object.values(obj)[0] === true;
      });

      const map = {};

      filteredInit?.forEach(obj => {
        Object.keys(obj).forEach(key => {
          map[key] = obj[key];
        });
      });

      let prefs = {
        [form_name]: { ...map }
      }
      if (!localPreferences) {
        localStorage.setItem('preferences', JSON.stringify(prefs))
      } else {
        if (!localPreferencesObj.hasOwnProperty(form_name)) {
          localPreferencesObj = {
            ...localPreferencesObj,
            form_name: { ...map }
          }
        }
      }
      dispatch(setPreferences(map))
    }
  }, [preferences])

  useEffect(() => {
    let localPreferences = localStorage.getItem('preferences')
    if (localPreferences && !isLoading) {
      let localPreferencesObj = JSON.parse(localPreferences)
      localPreferencesObj = {
        ...localPreferencesObj,
        [form_name]: data
      }
      localStorage.setItem('preferences', JSON.stringify(localPreferencesObj))

    }
  }, [data, isLoading])

  const handleTogglePreference = (key) => {
    dispatch(togglePreferenceAction({ key, preferences: preferences.data.data, form_name }));

    // Optionally, update the state with the latest preferences from localStorage
    const updatedPreferences = JSON.parse(localStorage.getItem('preferences'))[form_name];
    dispatch(setPreferences(updatedPreferences));
  };

  if (isLoading) return <><Loader /></>

  return (
    // <MinimizableContainer
    //   minimized={minimized}
    //   onMinimizeClick={() => setMinimized(!minimized)}
    //   Title={Title}
    //   style={preferencesStyle}
    //   OptionsButton={() => <StatsButton togglePreference={togglePreference} />}
    // >
    <Modal isOpen={isActive} toggle={handleClose} size="sm">
      <ModalHeader toggle={handleClose}>Préférences</ModalHeader>
      <ModalBody>
        <Form className="flex flex-col items-stretch flex-wrap gap-3">
          <FormGroup check>
            <Label className="w-auto" check>
              <Input
                type="checkbox"
                onChange={() => handleTogglePreference('TOUT SELECTIONNER')}
                checked={data?.['TOUT SELECTIONNER']}
                value={1}
              />
              (Sélectionner tout)
            </Label>
          </FormGroup>

          {preferences?.data?.data?.map((preference, index) => {
            const key = Object.keys(preference)[0];
            const isNonModifiable = preference[key] === true;

            return (
              <FormGroup check key={index}>
                <Label className="w-auto" check>
                  <Input
                    type="checkbox"
                    onChange={() => !isNonModifiable && handleTogglePreference(key)}
                    checked={data?.[key] || false}  // Ensure it reflects the state correctly
                    value={1}
                    disabled={isNonModifiable}
                  />
                  {key}
                </Label>
              </FormGroup>
            );
          })}


          {/* {preferences?.data?.data.map((val) =>
            <FormGroup check>
              <Label className="w-auto" check>
                <Input type="checkbox" value={1} />{' '}
                {key}
              </Label>
            </FormGroup>
          )} */}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={handleClose}>
          Fermer
        </Button>
      </ModalFooter>
    </Modal>
    // </Form >
    // </MinimizableContainer>
  );
};

function StatsButton({ togglePreference }) {
  return (
    <Button onClick={() => togglePreference()}>
      <i className="ti-bar-chart" />
    </Button>
  );
}

function Title({ style }) {
  return <h3 className="heading" style={style}>Preferences</h3>;
}

export default Preferences;
